import { render, staticRenderFns } from "./FormResultListEventRegistrations.vue?vue&type=template&id=1689f027&"
import script from "./FormResultListEventRegistrations.vue?vue&type=script&lang=js&"
export * from "./FormResultListEventRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports